import { selectConfigurationShoot } from '../../../../../../selectors';
import React, { useState } from 'react';
import ZoomModal from './ZoomModal';
import EditingIndicator from './EditingIndicator';
import BackgroundsConfig from './BackgroundsConfig';
import PosesConfig from './PosesConfig';
import { useSelector } from 'react-redux';
import { productRequiresConfigurationSelector } from '../../../../../../selectors/productConfig';

const BackgroundsPosesSelector = () => {
  const backgroundsPosesSelectorVisible = useSelector(
    (state) => state.productConfig.backgroundsPosesSelectorVisible,
  );
  const backgroundOptions = useSelector(
    (state) => selectConfigurationShoot(state).backgroundOptions,
  );
  const product = useSelector((state) => state.productConfig.currentProduct);
  const requiresConfiguration = useSelector(
    productRequiresConfigurationSelector,
  );

  const [zoomedBackgroundId, setZoomedBackgroundId] = useState(null);

  if (!product) return null;

  const handleZoomClick = (e, backgroundId) => {
    e.stopPropagation();
    setZoomedBackgroundId(
      zoomedBackgroundId === backgroundId ? null : backgroundId,
    );
  };

  if (!requiresConfiguration) {
    return null;
  }

  return (
    <>
      <div
        className={`backgroundsPosesContainer ${
          backgroundsPosesSelectorVisible ? 'element-visible' : 'element-hidden'
        }`}
      >
        <EditingIndicator />
        <PosesConfig />
        <BackgroundsConfig onZoomClick={handleZoomClick} />
      </div>
      <ZoomModal
        open={!!zoomedBackgroundId}
        imageUrl={
          backgroundOptions
            .flatMap((cat) => cat.background_images || [])
            .find((bg) => bg.id === zoomedBackgroundId)?.image_thumbnail
        }
        onClose={() => setZoomedBackgroundId(null)}
      />
    </>
  );
};

export default BackgroundsPosesSelector;
